




























import { Component, Vue } from 'vue-property-decorator'
import { index } from '@/api/merchant_mini_program_tasks'

@Component({
  components: {}
})

export default class extends Vue {
  screening: Record<string, any> = {
    status: 0
  }

  config: Record<string, any> = {
    api: index,
    paginate: true,
    include: 'store',
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'name', label: '主体' },
      { prop: 'code', label: '信用代码' },
      { prop: 'legal_persona_name', label: '法人', width: 120 },
      { prop: 'legal_persona_wechat', label: '微信', width: 150 },
      { prop: 'store', label: '门店', slot: true },
      { prop: 'contact_mobile', label: '联系电话', slot: true, width: 120 },
      { prop: 'status', label: '状态', slot: true, width: 100 },
      { prop: 'error_message', label: '错误信息', width: 150 },
      { prop: 'created_at', label: '申请时间', width: 150 }
    ]
  }
}
